import { i18n } from "@lingui/core";
import { plural, t, Trans } from "@lingui/macro";
import { I18nProvider } from "@lingui/react";
import React, { } from 'react';
import { Tag } from "antd";
import FileActions from 'bukku/redux/File/actions';
import {store} from 'bukku/redux/store';

const {
    deleteGlobalFiles,
} = FileActions;

// contains functions that do not deal with state management
export const FileViewHelper = {
    getModalTitle: (mode, fileTypeFilter) => {
        switch (mode) {
            case 'multiple':
                if (fileTypeFilter === 'IMAGE')
                    return t`Select Images`;
                return t`Select Files`;
            default:
                if (fileTypeFilter === 'IMAGE')
                    return `Select Image`;
                return t`Select File`;
        }
    },

    renderDeleteConfirmationContent: (isAllSelectedUsed, usedFiles, rowList) => {
        const inUseTextStyle = {
            textDecoration: 'line-through',
            color: '#bfbfbf', // grey-6
        };
        const inUseTagStyle = {
            margin: 0,
        };
        return (
            <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
                <div className={isAllSelectedUsed ? 'display-none' : undefined}>
                    <Trans>Do you really want to delete the following files?</Trans>
                </div>
                {
                    !!usedFiles.length && (
                        <div>
                            <Trans>
                                {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                                <Tag style={inUseTagStyle}>In Use</Tag> files will not be deleted.
                            </Trans>
                        </div>)
                }
                <br />
                <ul style={{ fontSize: '0.8rem', listStyleType: 'disc', paddingLeft: 14 }}>
                    {rowList.map(f => {
                        const inUse = f.used_count !== 0;
                        return (
                            <li key={f.id}>
                                <span style={{ ...(inUse && inUseTextStyle) }}>{f.filename}</span>
&nbsp;
                                {inUse && <Tag style={{ ...inUseTagStyle }}><Trans>In Use</Trans></Tag>}
                            </li>
                        );
                    })}
                </ul>
                <br />
                {/* Hide warning if all selections are used files */}
                <div className={isAllSelectedUsed ? 'display-none' : undefined}>
                    <strong><Trans>Warning: This cannot be undone.</Trans></strong>
                </div>
            </I18nProvider>
        );
    },

    getDeleteConfirmationModalProps: (onOk, rowList) => {
        const usedFiles = rowList.filter(f => f.used_count);
        const removeFiles = rowList.filter(f => !f.used_count);

        // rowList may contain files which have 0 used_count
        const isAllSelectedUsed = usedFiles.length === rowList.length;

        return {
            content: FileViewHelper
                .renderDeleteConfirmationContent(isAllSelectedUsed, usedFiles, rowList),
            onOk: () => {
                // delete files which are not used (from files)
                store.dispatch(deleteGlobalFiles({ids: removeFiles.map(f => f.id)}));
                // MODAL - delete from transaction/contact files list, true to keep modal visible
                if (onOk) // onOk only passed from modal, not from page
                    onOk({ remove: removeFiles }, true);
            },
            maskClosable: true,
            okText: plural(removeFiles.length, { one: 'Delete 1 file', other: 'Delete # files' }),
            okButtonProps: {
                danger: true,
                className: isAllSelectedUsed && 'display-none',
            },
            cancelText: isAllSelectedUsed ? t`Delete Other Files` : t`Cancel`,
        };
    },

    // vertical scroll to top for file manager items
    scrollToTop: () => {
        // scroll to top of file manager
        const fileIconListDocs = document.getElementsByClassName('file-list-icon-list');
        const fileTableDocs = document.getElementsByClassName('file-list-table');
        // for icon list
        for (let d = 0; d < fileIconListDocs.length; d += 1)
            fileIconListDocs[d].scrollTop = 0;

        // for file table
        for (let d = 0; d < fileTableDocs.length; d += 1)
            fileTableDocs[d].scrollTop = 0;
    },
};
